import { render, staticRenderFns } from "./CreateTruck.vue?vue&type=template&id=6b33940e&scoped=true&"
import script from "./CreateTruck.vue?vue&type=script&lang=js&"
export * from "./CreateTruck.vue?vue&type=script&lang=js&"
import style0 from "./CreateTruck.vue?vue&type=style&index=0&id=6b33940e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33940e",
  null
  
)

export default component.exports